import React from "react";
import styled from "styled-components";

function StepIndicator({ total = 3, current = 1 }) {
  const steps = Array.from({ length: total }, (_, i) => i + 1);
  return (
    <Wrap aria-label={`Step ${current} of ${total}`}>
      {steps.map((s) => (
        <Dot
          key={s}
          $isCurrent={s === current}
          $isCompleted={s < current}
        />
      ))}
    </Wrap>
  );
}

export default StepIndicator;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: ${(p) =>
    p.$isCurrent || p.$isCompleted ? "var(--color-primary)" : "transparent"};
  border: 2px solid
    ${(p) =>
      p.$isCurrent || p.$isCompleted
        ? "var(--color-primary)"
        : "var(--color-border)"};

  /* Desktop: active step is a pill, others stay circles */
  @media (min-width: 768px) {
    width: ${(p) => (p.$isCurrent ? "22px" : "6px")};
  }
`;

